import {
    type AccountInfo,
    type AuthenticationResult,
    type BrowserConfiguration,
    type IPublicClientApplication,
    type ITokenCache,
    Logger,
    LogLevel,
    PublicClientApplication,
} from "@azure/msal-browser";
import {
    defaultTestAccountInfo,
    defaultTestAuthenticationResult,
} from "src/tests/msal-tester/testerConstants";
import { msalConfig } from "./authConfig";

const GetNewClient = (
    testAccountInfo: AccountInfo,
    testAuthenticationResult: AuthenticationResult,
): IPublicClientApplication => {
    const logger = new Logger({
        loggerCallback: (_level: LogLevel, _message: string, _containsPii: boolean) => {},
        piiLoggingEnabled: false,
        logLevel: LogLevel.Error,
        correlationId: "mock_test",
    });

    return {
        initialize: () => Promise.resolve(),
        acquireTokenPopup: () => Promise.resolve(testAuthenticationResult),
        acquireTokenRedirect: () => Promise.resolve(),
        acquireTokenSilent: () => Promise.resolve(testAuthenticationResult),
        acquireTokenByCode: () => Promise.resolve(testAuthenticationResult),
        getAllAccounts: () => [testAccountInfo],
        getAccount: () => testAccountInfo,
        getAccountByHomeId: () => testAccountInfo,
        getAccountByUsername: () => testAccountInfo,
        getAccountByLocalId: () => testAccountInfo,
        handleRedirectPromise: () => Promise.resolve(testAuthenticationResult),
        loginPopup: () => Promise.resolve(testAuthenticationResult),
        loginRedirect: () => Promise.resolve(),
        logout: () => Promise.resolve(),
        logoutRedirect: () => Promise.resolve(),
        logoutPopup: () => Promise.resolve(),
        ssoSilent: () => Promise.resolve(testAuthenticationResult),
        addEventCallback: () => null,
        removeEventCallback: () => {
            return;
        },
        addPerformanceCallback: () => "",
        removePerformanceCallback: () => false,
        enableAccountStorageEvents: () => {
            return;
        },
        disableAccountStorageEvents: () => {
            return;
        },
        getTokenCache: () => ({}) as ITokenCache,
        setLogger: (_l: Logger) => {
            return logger;
        },
        getConfiguration: () => ({}) as BrowserConfiguration,
        hydrateCache: (..._params: unknown[]) => Promise.resolve(),
        setActiveAccount: () => {
            return;
        },
        getActiveAccount: () => testAccountInfo,
        initializeWrapperLibrary: () => {
            return;
        },
        setNavigationClient: () => {
            return;
        },
        getLogger: () => logger,
        clearCache: () => Promise.resolve(),
    };
};

export function createMsalInstance() {
    const isPlaywright =
        (window as any).__IS_PLAYWRIGHT__ || window.location.search.includes("isPlaywright=true");

    const msalInstance = isPlaywright
        ? GetNewClient(defaultTestAccountInfo, defaultTestAuthenticationResult)
        : new PublicClientApplication(msalConfig);

    return msalInstance;
}
